export const masterFirebaseConfig = {
  apiKey: "AIzaSyBm08DvXslUarlx6yUBfXgmEAFxmW15Vjg",
  authDomain: "foodsavorapp-b49fd.firebaseapp.com",
  databaseURL: "https://foodsavorapp-b49fd.firebaseio.com",
  projectId: "foodsavorapp-b49fd",
  storageBucket: "foodsavorapp-b49fd.appspot.com",
  messagingSenderId: "1084204054100"
};

export const recipeApiAppId = "6b7bcd48";

export const recipeApiKey = "c2b56f00b1429db775d0b0cdf7e5bacc";



// WEBPACK FOOTER //
// /Users/Guest/Desktop/Food-Savor/src/app/api-keys.ts